import React, { useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';

import './mobile-footer-style.scss';
import useIsComDomain from '@src/hooks/useIsComDomain';
import { MenuDataContext } from '@src/providers';

import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import GppGoodIcon from '@mui/icons-material/GppGood';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PaymentIcon from '@mui/icons-material/Payment';

import Logo from '@src/imagesNew/logo/maccaron-logo.jpg';
import GlobalStoreLogo from '@src/imagesNew/logo/global-store-logo.png';
import Facebook from '@src/imagesNew/icons/face-book.png';
import Instagram from '@src/imagesNew/icons/instagram.png';
import LinkedIn from '@src/imagesNew/icons/linked-in.png';
import Youtube from '@src/imagesNew/icons/youtube.png';
import AppleDownloadBadge from '@src/imagesNew/icons/app-store-badge.png';
import GoogleDownloadBadge from '@src/imagesNew/icons/google-play-badge.png';
import Mark from '@src/imagesNew/icons/mark.png';
import Visa from '@src/imagesNew/icons/visa.png';
import MasterCard from '@src/imagesNew/icons/master-card.png';
import Maestro from '@src/imagesNew/icons/maestro.png';
import Rupay from '@src/imagesNew/icons/rupay.png';
import DinersClub from '@src/imagesNew/icons/diners-club.png';

import Typography from '@src/componentsNew/Typography/Typography';

import { getRelativePath } from '@src/utils/urlCheck';
import { APP_STORE_URL, PLAY_STORE_URL } from '@src/utils/constants';

const MobileFooter = ({}) => {
  const history = useHistory();
  const isComDomain = useIsComDomain();

  const { aboutItems, supportItems, contactsItems } = useContext(MenuDataContext);

  return (
    <footer id="mobile-footer">
      <div className="footer-top-area">
        <img
          src={isComDomain ? GlobalStoreLogo : Logo}
          alt="logo"
          width={isComDomain ? 235 : 156}
          height={isComDomain ? 20 : 24}
        />

        <Typography cName="info-text" variant="body3" component="p" style={{ color: '#11141D99' }}>
          {isComDomain ? '100% Authentic K-beauty platform' : 'India’s biggest 100% Authentic K-beauty platform'}
        </Typography>

        {!isComDomain ? (
          <div className="social-media-area">
            <a href="https://www.facebook.com/maccaronnyou/" target="_blank">
              <img src={Facebook} alt="facebook" width={11} height={19} />
            </a>
            <a href="https://www.instagram.com/maccaron_beauty/" target="_blank">
              <img src={Instagram} alt="instagram" width={19} height={19} />
            </a>
            <a href="https://www.linkedin.com/company/maccaron/" target="_blank">
              <img src={LinkedIn} alt="linkedin" width={19} height={19} />
            </a>
            <a href="https://www.youtube.com/channel/UCa_5pdHSVunhVCo6j2Uvj5g" target="_blank">
              <img src={Youtube} alt="youtube" width={21} height={15} />
            </a>
          </div>
        ) : null}
      </div>

      <div className="app-download-banner-area">
        <a href={APP_STORE_URL} target="_blank">
          <img src={AppleDownloadBadge} />
        </a>
        <a href={PLAY_STORE_URL} target="_blank">
          <img src={GoogleDownloadBadge} />
        </a>
      </div>

      <div className="footer-main-area">
        {!isComDomain && aboutItems?.length ? (
          <div className="about-area">
            <Typography cName="footer-main-title" variant="h8" component="h6" style={{ color: '#090A0FDE' }}>
              About us
            </Typography>
            <ul className="footer-main-list-wrapper">
              {aboutItems.map((item, idx) => (
                <Typography key={idx} variant="body3" component="li" style={{ color: '#11141D99' }}>
                  <Link to={getRelativePath(item.url)}>{item.name}</Link>
                </Typography>
              ))}
            </ul>
          </div>
        ) : null}

        {supportItems?.length ? (
          <div className="support-area">
            <Typography cName="footer-main-title" variant="h8" component="h6" style={{ color: '#090A0FDE' }}>
              Support
            </Typography>
            <ul className="footer-main-list-wrapper">
              {supportItems.map((item, idx) => (
                <Typography key={idx} variant="body3" component="li" style={{ color: '#11141D99' }}>
                  <Link to={getRelativePath(item.url)}>{item.name}</Link>
                </Typography>
              ))}
            </ul>
          </div>
        ) : null}

        {contactsItems?.length ? (
          <div className="contacts-area">
            <Typography cName="footer-main-title" variant="h8" component="h6" style={{ color: '#090A0FDE' }}>
              Contacts us
            </Typography>
            <ul className="footer-main-list-wrapper">
              {contactsItems.map((item, idx) => (
                <Typography key={idx} variant="body3" component="li" style={{ color: '#11141D99' }}>
                  <Link to={getRelativePath(item.url)}>{item.name}</Link>
                </Typography>
              ))}
              <Typography cName="icon-list-item" variant="body3" component="li" style={{ color: '#11141D99' }}>
                <MailOutlineRoundedIcon style={{ fontSize: '20px', color: '#090A0FDE' }} />
                {isComDomain ? (
                  <a href="mailto:support@maccaron.com">support@maccaron.com</a>
                ) : (
                  <a href="mailto:support@maccaron.in">support@maccaron.in</a>
                )}
              </Typography>

              <Typography cName="icon-list-item" variant="body3" component="li" style={{ color: '#11141D99' }}>
                <img src={Mark} width={20} height={20} />
                {isComDomain ? (
                  <p> 7-27, 8, Gangnam-daero 53-gil, Seocho-gu, Seoul, Republic of Korea</p>
                ) : (
                  <p>
                    8th Floor, Tower C, Building No. 8, DLF
                    <br />
                    Cyber City, Phase 2, Sector 24, Gurugram,
                    <br />
                    Haryana 122010, India
                  </p>
                )}
              </Typography>
              {isComDomain && (
                <>
                  <Typography cName="icon-list-item" variant="body3" component="li" style={{ color: '#11141D99' }}>
                    <span>Name of company :</span>
                    <span>Vely Monkeys Co. Ltd.</span>
                  </Typography>

                  <Typography cName="icon-list-item" variant="body3" component="li" style={{ color: '#11141D99' }}>
                    <span>Name of representative :</span>
                    <span>Yu, Seungwan</span>
                  </Typography>

                  <Typography cName="icon-list-item" variant="body3" component="li" style={{ color: '#11141D99' }}>
                    <span>Business registration number :</span>
                    <span>384-88-01400</span>
                  </Typography>
                </>
              )}
            </ul>
          </div>
        ) : null}
      </div>

      {!isComDomain ? (
        <div className="footer-bottom-area">
          <div className="policy-link-wrapper">
            <Typography
              variant="body3"
              component="span"
              style={{ color: '#FF3399' }}
              onClick={() => history.push('/en/page/tnc/')}
            >
              Terms and Conditions
            </Typography>
            |
            <Typography
              variant="body3"
              component="span"
              style={{ color: '#FF3399' }}
              onClick={() => history.push('/en/page/privacypolicy/')}
            >
              Privacy Policy
            </Typography>
          </div>

          <div className="payments">
            <div className="payments-icon-wrapper">
              <GppGoodIcon style={{ fontSize: '20px' }} />
              <Typography variant="body3" component="span">
                100% Authentic
              </Typography>
            </div>

            <div className="payments-icon-wrapper">
              <DoneAllIcon style={{ fontSize: '20px' }} />
              <Typography variant="body3" component="span">
                Certified in India
              </Typography>
            </div>

            <div className="payments-icon-wrapper">
              <LocalShippingIcon style={{ fontSize: '20px' }} />
              <Typography variant="body3" component="span">
                Free shipping on orders above Rs.700
              </Typography>
            </div>

            <div className="payments-icon-wrapper">
              <PaymentIcon style={{ fontSize: '20px' }} />
              <Typography variant="body3" component="span">
                Secure Payments
              </Typography>
            </div>

            <div className="card-image-wrapper">
              <img src={Visa} width={52} />
              <img src={MasterCard} width={52} />
              <img src={Maestro} width={52} />
              <img src={Rupay} width={52} />
              <img src={DinersClub} width={52} />
            </div>
          </div>
        </div>
      ) : null}
    </footer>
  );
};

export default MobileFooter;
